import { useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { apiRoot } from "../../index";
import "moment/locale/fr";
import styled from "styled-components";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { pdfBase64ToBlob } from "../../store/actions/estimateActions";

const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

// let stripePublicKey = "pk_live_9xW1MoRlyjY8FPDMOwjKANRt";
// if (window.location.hostname === "localhost") {
//   stripePublicKey = "pk_test_dIaLBp3vJdXyQt0c0gy5RFSS";
// }

const estimateStatus = {
  draft: "Brouillon",
  open: "En attente de validation",
  sent: "En attente de validation",
  accepted: "Approuvé",
  invoiced: "Expiré",
  canceled: "Annulé",
  paid: "Payé",
};

const titlePerStatus = {
  draft: "Vérifier le devis",
  open: "Vérifier le devis",
  sent: "Vérifier le devis",
  accepted: "Payer le devis",
  invoiced: "Devis expiré",
  canceled: "Annuler le devis",
  paid: "Devis payé",
};

function SignEstimateContent() {
  const params = useParams();
  const [estimate, setEstimate] = useState(null);
  const [loadingApprove, setLoadingApprove] = useState(false);
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    if (!estimate?.stripeAccountId) return;
    setStripePromise(
      loadStripe(stripePublicKey, {
        stripeAccount: estimate.stripeAccountId,
      })
    );
  }, [estimate?.stripeAccountId]);
  const pdfObjectUrl = useMemo(() => {
    if (estimate) {
      const blob = pdfBase64ToBlob(estimate.pdfBase64);
      return URL.createObjectURL(blob);
    }

    return null;
  }, [estimate]);

  const fetchData = useCallback(async () => {
    const res = await axios.get(
      apiRoot + "/api/v1/estimate/" + params.uid + "/" + params.token
    );
    const data = res.data;
    setEstimate(data);
  }, [params.token, params.uid]);

  // Init booking datas
  useEffect(() => {
    if (!estimate) fetchData().then();
  }, [estimate, fetchData]);

  function approveEstimate() {
    setLoadingApprove(true);

    axios
      .get(
        apiRoot + "/api/v1/approve-estimate/" + params.uid + "/" + params.token
      )
      .finally(async () => {
        await fetchData();
        setLoadingApprove(false);
      });
  }

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main"></div>
        </div>
      </div>
      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label w-100 d-flex justify-content-between">
              <h3 className="kt-portlet__head-title">
                {estimate ? (
                  <>{titlePerStatus[estimate?.status] || "Vérifier le devis"}</>
                ) : (
                  <>Loading...</>
                )}
              </h3>
            </div>
          </div>
          {estimate &&
            (estimate.status === "open" ||
              estimate.status === "sent" ||
              estimate.status === "accepted" ||
              estimate.status === "invoiced" ||
              estimate.status === "paid") && (
              <Cols>
                <div>
                  <PdfViewer
                    aria-label="PDF Devis"
                    src={pdfObjectUrl}
                    title="devis.pdf"
                    height="950px"
                    type="application/pdf"
                  />
                </div>
                <div>
                  <RecapContainer>
                    <RecapHeader>
                      <strong>Devis {estimate.id}</strong>
                      <EstimateStatus>
                        {estimateStatus[estimate.status]}
                      </EstimateStatus>
                    </RecapHeader>
                    <EstimatePrice>
                      {new Intl.NumberFormat("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      }).format(estimate.price)}
                    </EstimatePrice>
                    {(estimate.status === "open" ||
                      estimate.status === "sent") && (
                      <button
                        className="btn btn-primary"
                        onClick={approveEstimate}
                        disabled={loadingApprove}
                      >
                        {loadingApprove
                          ? "Validation du devis..."
                          : "Approuver le devis"}
                      </button>
                    )}
                    {estimate.status === "accepted" &&
                      estimate.checkoutSessionClientSecret &&
                      stripePromise && (
                        <EmbeddedCheckoutProvider
                          stripe={stripePromise}
                          options={{
                            clientSecret: estimate.checkoutSessionClientSecret,
                          }}
                        >
                          <EmbeddedCheckout />
                        </EmbeddedCheckoutProvider>
                      )}
                  </RecapContainer>
                </div>
              </Cols>
            )}
        </div>
      </div>
    </div>
  );
}

const Cols = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
  padding: 24px;
`;

const PdfViewer = styled.embed`
  width: 100%;
  border: 1px solid #777;
  border-radius: 5px;
`;

const RecapContainer = styled.div`
  width: 360px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
`;

const RecapHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const EstimateStatus = styled.span`
  background: #ececec;
  padding: 4px;
  border-radius: 5px;
  white-space: nowrap;
`;

const EstimatePrice = styled.span`
  font-size: 24px;
  font-weight: bold;
  margin-top: 12px;
  margin-bottom: 32px;
  display: block;
`;

export default SignEstimateContent;
